<script setup lang="ts">
import { computed } from 'vue'
import router from '@/router'
import SettingsPagePanel from '../SettingsPagePanel.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import {
  useUpdateInflowSourceDefinitionMutation,
  useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery,
} from './SettingsPageLineActivationInflowSourceView.generated'
import SettingPageLineActivationInflowSourceForm, {
  type InflowSourceDefinitionForm,
} from './SettingPageLineActivationInflowSourceForm.vue'
import { useRoute } from 'vue-router'

const route = useRoute('LineActivationSettingInflowSourceEdit')

const guid = route.params.inflowSourceId
const { result } =
  useFetchSettingsPageLineActivationInflowSourceDefinitionEditViewQuery(
    {
      guid,
    },
    { fetchPolicy: 'no-cache' }
  )
const { mutate } = useUpdateInflowSourceDefinitionMutation()

const form = computed<InflowSourceDefinitionForm | undefined>(() =>
  result.value
    ? {
        inflowSourceName:
          result.value.userRegistrationInflowSourceDefinition.inflowSourceName,
        useShortenedURL:
          result.value.userRegistrationInflowSourceDefinition.useShortenedURL,
      }
    : undefined
)

const save = async (v: InflowSourceDefinitionForm) => {
  await mutate({
    input: {
      guid,
      inflowSourceName: v.inflowSourceName,
      useShortenedURL: v.useShortenedURL,
    },
  })

  // eslint-disable-next-line fp/no-mutating-methods
  router.push({ name: 'LineActivationSettingInflowSource' })
}
</script>

<template>
  <SettingsPagePanel>
    <SettingsPagePanelHeader>
      <template #title>友だち追加経路 編集</template>
    </SettingsPagePanelHeader>
    <SettingPageLineActivationInflowSourceForm
      v-if="form"
      :form="form"
      @save="save"
    />
  </SettingsPagePanel>
</template>
